import { Named } from './named';
import { Metamodel } from './model';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { IModel } from './annotation';
import { NamedCompositeValidator } from './named-composite-validator';
import { NamedValidations } from './named-validations';

@Metamodel.model({
    name: 'libraryvariable',
    display: [shellStringResources.LibraryVariable, shellStringResources.LibraryVariables],
    referable: true,
    globalScope: true,
    constraints: {
        name: {
            required: true,
            validator: NamedCompositeValidator.CreateValidator([
                NamedValidations.KeyWordsValidator,
                NamedValidations.StartsWithNumberValidator
            ])
        },
        variableName: {
            required: true
        },
        libraryName: {
            required: true
        },
        _type: {
            required: true
        }
    }
})
export class LibraryVariable extends Named {
    public static readonly MODEL: IModel;

    public variableName: string;
    public libraryName: string;
    public note?: string;
    public value?: string | Record<string, unknown>;

    @Metamodel.attribute({
        constraint: {
            required: true,
        },
        display: shellStringResources.Type
    })
    public _type?: string;
    // the raw type of the variable as defined in the library
    public _rawType?: 'ConnectionReference' | 'ItemReference' | string;

    constructor(name?: string, description?: string, id?: number) {
        super(name, description, id);
    }
}
